import React, { Component } from 'react';
import { Modal, message } from 'antd';
import VisitServiceModal from './VisitServiceModal';
import VisitEmployeeModal from './VisitEmployeeModal';
import VisitCarrierModal from './VisitCarrierModal';
import VisitVisitorModal from './VisitVisitorModal';
import Configuration from '../../Configuration';
import axios from 'axios';

class VisitKindModal extends Component {
  constructor(props) {
    super(props);
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {serviceVisible: false, employeeVisible: false, carrierVisible: false, visitorVisible: false, rol: localStorage.getItem('visitapp:rol')};
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleSaveService = this.handleSaveService.bind(this);
    this.handleSaveEmployee = this.handleSaveEmployee.bind(this);
    this.handleSaveCarrier = this.handleSaveCarrier.bind(this);
    this.handleSaveVisitor = this.handleSaveVisitor.bind(this);
    this.handleAssignVisitors = this.handleAssignVisitors.bind(this);
  }

  handleOpenModal(kind) {
    let modal = {};
    modal[kind] = true;
    this.setState(modal);
  }

  handleCloseModal(kind) {
    let modal = {};
    modal[kind] = false;
    this.setState(modal);
  }

  handleSaveService(visit) {
    const quick = this.props.quick || false;

    const sendData = {visit_kind: {service_id: visit.service_id}, visit: {quick: quick, subject: `Visita de servicio ${visit.service_name}`, transport_id: visit.transport_id, details: visit.details, due_date: new Date(`${visit.due_date} ${visit.time}`)}};

    axios.post(`${Configuration.apiServer}/api/v1/service-visits`, sendData, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida');
      
      this.handleCloseModal('serviceVisible');
      this.props.handleList(1);
      message.success('Visita creada');
    });
  }

  handleSaveEmployee(visit) {
    const quick = this.props.quick || false;
    
    const sendData = {visit: {quick: quick, subject: `Visita del empleado ${visit.profile_name}`, transport_id: visit.transport_id, details: visit.details, due_date: new Date(`${visit.due_date} ${visit.time}`), profile_id: visit.profile_id}};
    
    axios.post(`${Configuration.apiServer}/api/v1/employee-visits`, sendData, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida');
      
      this.handleCloseModal('employeeVisible');
      this.props.handleList(1);
      message.success('Visita creada');
    });
  }

  handleSaveCarrier(visit) {
    const quick = this.props.quick || false;
    
    const sendData = {visit_ticket: {driver_id: visit.driver_id, truck_id: visit.truck_id, truck_kind_id: visit.truck_kind_id, visit_ticket_kind_id: visit.visit_ticket_kind_id, carrier_id: visit.carrier_id, warehouse_id: visit.warehouse_id, weight_limit: visit.weight_limit},  visit: {quick: quick, subject: `Visita del transportista ${visit.carrier_name}`, details: visit.details, due_date: new Date(`${visit.due_date} ${visit.time}`)}};
    
    axios.post(`${Configuration.apiServer}/api/v1/carrier-visits`, sendData, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida');
      
      this.handleCloseModal('carrierVisible');
      this.props.handleList(1);
      message.success('Visita creada');
    });
  }

  handleSaveVisitor(visit) {
    const quick = this.props.quick || false;
    
    const sendData = {visit: {quick: quick, subject: `Visita para ${visit.subject}`, transport_id: visit.transport_id, details: visit.details, due_date: new Date(`${visit.due_date} ${visit.time}`), profile_id: visit.profile_id}};
    
    axios.post(`${Configuration.apiServer}/api/v1/visitor-visits`, sendData, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida');
      
      this.handleCloseModal('visitorVisible');
      this.handleAssignVisitors(resp.data.visit, visit.visitors);
      this.props.handleList(1);
      message.success('Visita creada');
    });
  }

  handleAssignVisitors(visit, visitors) {
    visitors.forEach(visitor => {
      axios.post(`${Configuration.apiServer}/api/v1/visitor-visits/people`, {visit: {visit_id: visit, visitor_id: visitor}}, {headers: this.headers}).then(resp => {
      });
    });
  }

  render() {
    return (
      <div>
        <Modal
          title={this.props.title}
          visible={this.props.visible}
          onCancel={this.props.handleClose}
          width={800}
          footer={null}
          destroyOnClose={true}
        >
          <div className="row" style={{ padding: '0px 30px' }}>
            <div className="card box-shadow-light" style={{ color: 'rgb(255, 255, 255)', background: 'rgb(89, 136, 222)', margin: '10px', width: '100%', height: '120px', display: Configuration.displayElement(this.props.service) }} onClick={() => { this.handleOpenModal('serviceVisible') }}>
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <div>
                    <p className="h4 mt-2">Visita para Servicio</p> 
                    <p style={{ color: 'rgb(221, 221, 221)' }}>Servicios como agua, luz, internet</p>
                  </div> 
                  <div className="d-flex align-items-center"><i className="material-icons">arrow_forward</i></div>
                </div>
              </div>
            </div>

            {!Configuration.isInRol(this.state.rol, "empleado") ? 
              <div className="card box-shadow-light" style={{ color: 'rgb(255, 255, 255)', background: 'rgb(89, 136, 222)', margin: '10px', width: '100%', height: '120px', display: Configuration.displayElement(this.props.employee) }} onClick={() => { this.handleOpenModal('employeeVisible') }}>
                <div className="card-body">
                  <div className="d-flex justify-content-between">
                    <div>
                      <p className="h4 mt-2">Visita de Empleado</p> 
                      <p style={{ color: 'rgb(221, 221, 221)' }}>Entradas y salidas de la planta</p>
                    </div> 
                    <div className="d-flex align-items-center"><i className="material-icons">arrow_forward</i></div>
                  </div>
                </div>
              </div>
              : null
            }

            {!Configuration.isInRol(this.state.rol, "empleado") ? 
              <div className="card box-shadow-light" style={{ color: 'rgb(255, 255, 255)', background: 'rgb(89, 136, 222)', margin: '10px', width: '100%', height: '120px', display: Configuration.displayElement(this.props.carrier) }} onClick={() => { this.handleOpenModal('carrierVisible') }}>
                <div className="card-body">
                  <div className="d-flex justify-content-between">
                    <div>
                      <p className="h4 mt-2">Visita para Transportista</p> 
                      <p style={{ color: 'rgb(221, 221, 221)' }}>Carga y descarga de material</p>
                    </div> 
                    <div className="d-flex align-items-center"><i className="material-icons">arrow_forward</i></div>
                  </div>
                </div>
              </div>
              : null 
            }

            <div className="card box-shadow-light" style={{ color: 'rgb(255, 255, 255)', background: 'rgb(89, 136, 222)', margin: '10px', width: '100%', height: '120px', display: Configuration.displayElement(this.props.visitor) }} onClick={() => { this.handleOpenModal('visitorVisible') }}>
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <div>
                    <p className="h4 mt-2">Visita a Planta</p> 
                    <p style={{ color: 'rgb(221, 221, 221)' }}>Visitantes externos</p>
                  </div> 
                  <div className="d-flex align-items-center"><i className="material-icons">arrow_forward</i></div>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {/* Visits modals */}
        <VisitServiceModal visible={this.state.serviceVisible} handleClose={this.handleCloseModal} handleSave={this.handleSaveService} hideDate={this.props.hideDate} />
        {!Configuration.isInRol(this.state.rol, "empleado") ? 
          <VisitEmployeeModal visible={this.state.employeeVisible} handleClose={this.handleCloseModal} handleSave={this.handleSaveEmployee} hideDate={this.props.hideDate} />
          : null 
        }
        {!Configuration.isInRol(this.state.rol, "empleado") ? 
          <VisitCarrierModal visible={this.state.carrierVisible} handleClose={this.handleCloseModal} handleSave={this.handleSaveCarrier} hideDate={this.props.hideDate} />
          : null 
        }
        <VisitVisitorModal visible={this.state.visitorVisible} handleClose={this.handleCloseModal} handleSave={this.handleSaveVisitor} hideDate={this.props.hideDate} />
      </div>
    );
  }
}

export default VisitKindModal;



// WEBPACK FOOTER //
// ./src/components/modals/VisitKindModal.js